
document.addEventListener('DOMContentLoaded', function () {
    var formNewsletter = document.getElementById('newsletter');
    if(!formNewsletter) return;
    var btn = document.getElementById('btn-newsletter');
    var emailInput = document.getElementById('newsletterEmail');
    formNewsletter.addEventListener('submit', async function(e){
        e.preventDefault();
        if(!emailInput.checkValidity()) { emailInput.reportValidity(); return; }
        try {
            btn.disabled = true; btn.classList.add('disabled');
            var fd = new FormData(formNewsletter);
            var res = await fetch(formNewsletter.action, { method: 'POST', headers: { 'X-Requested-With':'XMLHttpRequest' }, body: fd });
            var data = {};
            try { data = await res.json(); } catch (_){ }
            if(!res.ok || (data && data.status === 'error')){
                var msg = 'Error';
                if(data && data.errors && data.errors.email){ msg = data.errors.email.join(', '); }
                else if(data && data.message){ msg = data.message; }
                alert(msg);
                return;
            }
            emailInput.value='';
            alert(data.message || 'Subscribed successfully');
        } catch(err){
            alert('Unable to subscribe right now.');
        } finally {
            btn.disabled = false; btn.classList.remove('disabled');
        }
    });
});
